export default __webpack_public_path__ + "static/media/Manuable_ecommerce.db10ceb5.png";